export const enum SectionTypes {
  VirtualSection = 'virtual',
  Section = 'section',
  Header = 'header',
  Footer = 'footer',
}
